import { render, staticRenderFns } from "./Threads.vue?vue&type=template&id=f7c34236"
import script from "./Threads.vue?vue&type=script&lang=js"
export * from "./Threads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports